// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"_89b4965636--fullscreen--mfCte","no-print":"_89b4965636--no-print--WH57H"};